// extracted by mini-css-extract-plugin
export var hideEditor = "_ru-2";
export var infoIcon = "_ru-3";
export var label = "_ru-1";
export var labelContainer = "_ru-0";
export var readonlyText = "_ru-4";